// extracted by mini-css-extract-plugin
export default {"blockquote":"jPurc","sizeM":"uqJlO","sizeS":"XRXCo"};